import { Skeleton } from 'antd';
import * as Styled from './styles';

type TNftMediaSkeletonProps = {
  className?: string;
};

export const NftMediaSkeleton = ({ className }: TNftMediaSkeletonProps) => {
  return (
    <Styled.ImageWrapper $scalable={false} className={className}>
      <Skeleton.Image
        active
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%'
        }}
      />
    </Styled.ImageWrapper>
  );
};
